import React from 'react'

import logo from '../../images/ppa_logo.png'

const Header = () => (
  <div className='App-header'>
    <img src={logo} className='App-logo' alt='logo' />
  </div>
)

export default Header
